export const BRAND_NAME = {
  OPPIZI: 'oppizi',
  PROMOFY: 'promofy',
}

export const brandTheme = (myTheme = null) => {
  if (
    process.env.REACT_APP_THEME_PRIMARY_COLOUR &&
    process.env.REACT_APP_THEME_SECONDARY_COLOUR
  ) {
    return {
      colors: {
        primary: process.env.REACT_APP_THEME_PRIMARY_COLOUR,
        secondary: process.env.REACT_APP_THEME_SECONDARY_COLOUR,
      },
    }
  }

  const theme = myTheme || process.env.REACT_APP_THEME
  // const theme = process.env.REACT_APP_THEME
  switch (theme) {
    case BRAND_NAME.OPPIZI:
      return {
        colors: {
          primary: '#EE4360',
          secondary: '#273754',
        },
      }
    case BRAND_NAME.PROMOFY:
      return {
        colors: {
          primary: '#004360',
          secondary: '#546b81',
        },
      }
    default:
      return null
  }
}

export default brandTheme



// WEBPACK FOOTER //
// ./src/Assets/Styles/brandTheme.js